module.exports = __webpack_public_path__ + "static/media/double-down.a46b5ba5.svg";